/**
* @fileOverview Disqus Services for Blog.
* Ignored for istanbul coverage report as Blog is outsourced at present.
*/
/* istanbul ignore next */
angular.module('dpw.components')
    .value('getDisqusScript', function (shortname, name) {
        var s = document.createElement('script');
        s.async = true;
        s.type = 'text/javascript';
        s.src = '//' + shortname + '.disqus.com/' + name;
        (document.getElementsByTagName('HEAD')[0] ||
            document.getElementsByTagName('BODY')[0]).appendChild(s);
    })
    .factory('disqus', [
        '$window', '$location', 'getDisqusScript',
        function ($window, $location, getDisqusScript) {
            return {
                count: function (shortname) {
                    $window.disqus_shortname = shortname;

                    !$window.DISQUSWIDGETS ?
                        getDisqusScript(shortname, 'count.js') :
                        $window.DISQUSWIDGETS.getCount({
                            reset: true
                        });
                },
                comment: function (shortname, identifier, url) {
                    $window.disqus_shortname = shortname;
                    $window.disqus_identifier =  identifier;
                    $window.disqus_url = url || $location.absUrl();

                    !$window.DISQUS  ?
                        getDisqusScript(shortname, 'embed.js') :
                        $window.DISQUS.reset({
                            reload: true,
                            config: function () {
                                this.page.identifier = $window.disqus_identifier;
                                this.page.url = $window.disqus_url;
                            }
                        });
                }
            };
        }
    ]);